import { MDSDropdown } from '@marqvision/mds-v2';
import { useQueryParams } from '@marqvision/shared';
import { useDomainStatusFilterQuery } from '~/apis/domainNames';
import { useLogger } from '~/hooks';
import { useTab } from '~/pages/DomainNames/@hooks/useTab';
import { FilterQueryParams } from '~/pages/DomainNames/@types';
import { useRequest } from '~/pages/DomainNames/List/@hooks/useRequest';
import { MarqCommonEnumsSwAiLabelEnum } from '~/swagger/data-contracts';
import { parseDropDown, parseValueToValueArray } from '~/utils';

export const AIClassificationFilter = () => {
  const { currentTabGroup } = useTab();
  const { amplitudeLogging } = useLogger();

  const { params, setParams } = useQueryParams<FilterQueryParams>();
  const { request } = useRequest();

  const { data } = useDomainStatusFilterQuery(request, {
    select: parseDropDown<MarqCommonEnumsSwAiLabelEnum>,
  });
  const list = data?.list || [];

  const selectedStatus = params.domain_status_filter ? parseValueToValueArray(params.domain_status_filter) : [];

  const handleChange = (value: MarqCommonEnumsSwAiLabelEnum[]) => {
    setParams({ domain_status_filter: value });

    if (value.length > 0) {
      amplitudeLogging('applied filter', {
        Type: 'ai classification',
        Channel: 'domain names',
        Page: currentTabGroup.replace(/-/g, ' '),
        Option: value,
      });
    }
  };

  return <MDSDropdown label="AI Classification" value={selectedStatus} list={list} onChange={handleChange} />;
};
